import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISiteSAMLConfiguration } from '../types/ISiteSAMLConfiguration';

export class RemoveIdentityProviderRequest extends Request<{}, ISiteSAMLConfiguration> {
  constructor() {
    super('removeIdentityProvider', {});
  }
}
